import { SWITCH_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useSwitchList } from './hook';
import { SwitchListProps } from './props';

export const SwitchList = ({ filters }: SwitchListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSwitchList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${SWITCH_DETAIL}/${item.row.id}`, '_blank')
            }
        />
    );
};
